
<!-- Area -->
<drop-down-list (onSelected)="onInputChange($event)"
                (onSearchChanged)="onSearchChanged($event)"
                [errorHandling]="errorHandling"
                floatingLabel="Area"
                [group]="group"
                id= "{{id}}"
                [isLoading]="isLoading"
                [validators]="validators"
                [allowEditing] = true
                [connectToServer] = true>
</drop-down-list>

